import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { MspTableService } from '../msp-table/service/msp-table.service';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
	standalone: true,
	imports: [CommonModule, FontAwesomeModule],
	selector: 'cpi-pagination-counter',
	templateUrl: './pagination-counter.component.html',
	styleUrls: ['./pagination-counter.component.scss'],
})
export class PaginationCounterComponent implements OnInit, OnChanges {
	icons = {
		faAngleRight: faAngleRight,
		faAngleDoubleRight: faAngleDoubleRight,
		faAngleLeft: faAngleLeft,
		faAngleDoubleLeft: faAngleDoubleLeft,
	};

	@Output()
	start = new EventEmitter();
	@Output()
	end = new EventEmitter();

	constructor(private MspTableService: MspTableService) {}

	@Input()
	arrayLength: number;

	@Input()
	itemsPerPage: number = this.MspTableService.getTableConfig('itemsPerPage');

	@Input()
	setCurrentPage = 1;
	@Output()
	getCurrentPage = new EventEmitter<number>();
	_currentPage = 1;
	maxPages = 0;
	numberOfPages: number[] = [];
	_start = 0;
	_end = 0;

	ngOnInit(): void {
		if (this.arrayLength == undefined || this.itemsPerPage == undefined)
			throw 'Pagination Counter mandatory parameters not fulfilled (arrayLength, itemsPerPage)';
		this.maxPages = Math.ceil(this.arrayLength / this.itemsPerPage);
		this.setNumberOfPages(true);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if ((changes && changes.arrayLength) || (changes && changes.itemsPerPage)) {
			this.maxPages = Math.ceil(this.arrayLength / this.itemsPerPage);
			this._currentPage = 1;
			this.setNumberOfPages(true);
		}

		if (changes && changes.setCurrentPage) {
			this._currentPage = this.setCurrentPage;
		}
	}

	setNumberOfPages(firstTime: boolean): void {
		this.numberOfPages = [];

		if (this.maxPages <= 9) {
			for (let index = 1; index <= this.maxPages; index++) {
				this.numberOfPages.push(index);
			}
		} else {
			if (this._currentPage == 1 || this._currentPage == 2 || this._currentPage == 3) {
				for (let index = 1; index <= 7; index++) {
					this.numberOfPages.push(index);
				}
				this.numberOfPages.push(0, this.maxPages);
			} else if (
				this._currentPage == this.maxPages ||
				this._currentPage == this.maxPages - 1 ||
				this._currentPage == this.maxPages - 2
			) {
				for (let index = this.maxPages; index >= this.maxPages - 6; index--) {
					this.numberOfPages.unshift(index);
				}
				this.numberOfPages.unshift(0);
				this.numberOfPages.unshift(1);
			} else {
				this.numberOfPages.push(
					1,
					0,
					this._currentPage - 2,
					this._currentPage - 1,
					this._currentPage,
					this._currentPage + 1,
					this._currentPage + 2,
					0
				);
				this.numberOfPages.push(this.maxPages);
			}
		}

		this._start = this._currentPage == 1 ? 0 : (this._currentPage - 1) * this.itemsPerPage;
		this._end = this._currentPage * this.itemsPerPage;
		this.emitStartAndEndIndexes();

		if (!firstTime) this.emitSelectedPage();
	}

	emitStartAndEndIndexes(): void {
		this.start.emit(this._start);
		this.end.emit(this._end);
	}

	emitSelectedPage(): void {
		this.getCurrentPage.emit(this._currentPage);
	}
}
